import {
  DELETE_EXPENSE_SUMMARY_REQUEST,
  DELETE_EXPENSE_SUMMARY_SUCCESS,
  DELETE_EXPENSE_SUMMARY_FAILURE,
  GET_EXPENSE_SUMMARIES_REQUEST,
  GET_EXPENSE_SUMMARIES_SUCCESS,
  GET_EXPENSE_SUMMARIES_FAILURE,
  POST_EXPENSE_SUMMARY_REQUEST,
  POST_EXPENSE_SUMMARY_SUCCESS,
  POST_EXPENSE_SUMMARY_FAILURE,
  UPDATE_EXPENSE_SUMMARY_REQUEST,
  UPDATE_EXPENSE_SUMMARY_SUCCESS,
  UPDATE_EXPENSE_SUMMARY_FAILURE,
  GET_EXPENSE_LINES_FAILURE,
  GET_EXPENSE_LINES_REQUEST,
  GET_EXPENSE_LINES_SUCCESS,
  UPDATE_EXPENSE_LINE_FAILURE,
  UPDATE_EXPENSE_LINE_REQUEST,
  UPDATE_EXPENSE_LINE_SUCCESS,
  POST_EXPENSE_LINE_FAILURE,
  POST_EXPENSE_LINE_REQUEST,
  POST_EXPENSE_LINE_SUCCESS,
  DELETE_EXPENSE_LINE_FAILURE,
  DELETE_EXPENSE_LINE_REQUEST,
  DELETE_EXPENSE_LINE_SUCCESS,
  GET_VOUCHER_SUMMARIES_REQUEST,
  GET_VOUCHER_SUMMARIES_SUCCESS,
  GET_VOUCHER_SUMMARIES_FAILURE,
  POST_VOUCHER_SUMMARY_REQUEST,
  POST_VOUCHER_SUMMARY_SUCCESS,
  POST_VOUCHER_SUMMARY_FAILURE,
  UPDATE_VOUCHER_SUMMARY_REQUEST,
  UPDATE_VOUCHER_SUMMARY_SUCCESS,
  UPDATE_VOUCHER_SUMMARY_FAILURE,
  DELETE_VOUCHER_SUMMARY_REQUEST,
  DELETE_VOUCHER_SUMMARY_SUCCESS,
  DELETE_VOUCHER_SUMMARY_FAILURE,
  GET_CLIENT_PREFERRED_EXPENSE_CODES_REQUEST,
  GET_CLIENT_PREFERRED_EXPENSE_CODES_SUCCESS,
  GET_CLIENT_PREFERRED_EXPENSE_CODES_FAILURE,
  GET_VOUCHER_SUMMARY_BY_ID_FAILURE,
  GET_VOUCHER_SUMMARY_BY_ID_REQUEST,
  GET_VOUCHER_SUMMARY_BY_ID_SUCCESS,
  GET_EXPENSE_SUMMARY_BY_ID_FAILURE,
  GET_EXPENSE_SUMMARY_BY_ID_REQUEST,
  GET_EXPENSE_SUMMARY_BY_ID_SUCCESS,
  POST_EXPENSE_LINE_ITEM_BULK_REQUEST,
  POST_EXPENSE_LINE_ITEM_BULK_SUCCESS,
  POST_EXPENSE_LINE_ITEM_BULK_FAILURE,
  GET_VOUCHER_LINES_SUCCESS,
  GET_VOUCHER_LINES_FAILURE,
  GET_VOUCHER_LINES_REQUEST,
  POST_VOUCHER_LINE_REQUEST,
  POST_VOUCHER_LINE_SUCCESS,
  POST_VOUCHER_LINE_FAILURE,
  UPDATE_VOUCHER_LINE_FAILURE,
  UPDATE_VOUCHER_LINE_SUCCESS,
  UPDATE_VOUCHER_LINE_REQUEST,
  DELETE_VOUCHER_LINE_REQUEST,
  DELETE_VOUCHER_LINE_SUCCESS,
  DELETE_VOUCHER_LINE_FAILURE,
  POST_VOUCHER_LINE_ITEM_BULK_FAILURE,
  POST_VOUCHER_LINE_ITEM_BULK_SUCCESS,
  POST_VOUCHER_LINE_ITEM_BULK_REQUEST,
  GET_EXPENSE_BY_AUTHORIZATION_REQUEST,
  GET_EXPENSE_BY_AUTHORIZATION_SUCCESS,
  GET_EXPENSE_BY_AUTHORIZATION_FAILURE,
  GET_APPROVED_LINEITEM_SUMMARIES_REQUEST,
  GET_APPROVED_LINEITEM_SUMMARIES_SUCCESS,
  GET_APPROVED_LINEITEM_SUMMARIES_FAILURE,
  GET_APPROVED_LINEITEM_REQUEST,
  GET_APPROVED_LINEITEM_SUCCESS,
  GET_APPROVED_LINEITEM_FAILURE,
  UPDATE_APPROVED_LINEITEM_REQUEST,
  UPDATE_APPROVED_LINEITEM_SUCCESS,
  UPDATE_APPROVED_LINEITEM_FAILURE,
  POST_APPROVED_TAX_REQUEST,
  POST_APPROVED_TAX_SUCCESS,
  POST_APPROVED_TAX_FAILURE,
  UPDATE_APPROVED_TAX_REQUEST,
  UPDATE_APPROVED_TAX_SUCCESS,
  UPDATE_APPROVED_TAX_FAILURE,
  DELETE_APPROVED_TAX_REQUEST,
  DELETE_APPROVED_TAX_SUCCESS,
  DELETE_APPROVED_TAX_FAILURE,
  POST_VOUCHER_ATTACHMENT_REQUEST,
  POST_VOUCHER_ATTACHMENT_SUCCESS,
  POST_VOUCHER_ATTACHMENT_FAILURE,
  UPDATE_VOUCHER_ATTACHMENT_REQUEST,
  UPDATE_VOUCHER_ATTACHMENT_SUCCESS,
  UPDATE_VOUCHER_ATTACHMENT_FAILURE,
  DELETE_VOUCHER_ATTACHMENT_REQUEST,
  DELETE_VOUCHER_ATTACHMENT_SUCCESS,
  DELETE_VOUCHER_ATTACHMENT_FAILURE,
  POST_VOUCHER_LINE_ATTACHMENT_REQUEST,
  POST_VOUCHER_LINE_ATTACHMENT_SUCCESS,
  POST_VOUCHER_LINE_ATTACHMENT_FAILURE,
  DELETE_VOUCHER_LINE_ATTACHMENT_REQUEST,
  DELETE_VOUCHER_LINE_ATTACHMENT_SUCCESS,
  DELETE_VOUCHER_LINE_ATTACHMENT_FAILURE,
  POST_EXPENSE_ATTACHMENT_REQUEST,
  POST_EXPENSE_ATTACHMENT_SUCCESS,
  POST_EXPENSE_ATTACHMENT_FAILURE,
  UPDATE_EXPENSE_ATTACHMENT_REQUEST,
  UPDATE_EXPENSE_ATTACHMENT_SUCCESS,
  UPDATE_EXPENSE_ATTACHMENT_FAILURE,
  DELETE_EXPENSE_ATTACHMENT_REQUEST,
  DELETE_EXPENSE_ATTACHMENT_SUCCESS,
  DELETE_EXPENSE_ATTACHMENT_FAILURE,
  POST_EXPENSE_LINE_ATTACHMENT_REQUEST,
  POST_EXPENSE_LINE_ATTACHMENT_SUCCESS,
  POST_EXPENSE_LINE_ATTACHMENT_FAILURE,
  DELETE_EXPENSE_LINE_ATTACHMENT_REQUEST,
  DELETE_EXPENSE_LINE_ATTACHMENT_SUCCESS,
  DELETE_EXPENSE_LINE_ATTACHMENT_FAILURE,
  SET_CURRENT_VOUCHER_ID,
  SET_CURRENT_RECURRING_PAYABLE_ID,
  SET_CURRENT_EXPENSE_ID,
  GET_EXCEPTIONS_BY_CLIENT_ID_REQUEST,
  GET_EXCEPTIONS_BY_CLIENT_ID_SUCCESS,
  GET_EXCEPTIONS_BY_CLIENT_ID_FAILURE,
  GET_EXCEPTIONS_BY_AUTHORIZATION_ID_REQUEST,
  GET_EXCEPTIONS_BY_AUTHORIZATION_ID_SUCCESS,
  GET_EXCEPTIONS_BY_AUTHORIZATION_ID_FAILURE,
  POST_PUSH_VOUCHER_TO_ACUMATICA_REQUEST,
  POST_PUSH_VOUCHER_TO_ACUMATICA_SUCCESS,
  POST_PUSH_VOUCHER_TO_ACUMATICA_FAILURE,
  POST_PUSH_EXPENSE_TO_ACUMATICA_REQUEST,
  POST_PUSH_EXPENSE_TO_ACUMATICA_SUCCESS,
  POST_PUSH_EXPENSE_TO_ACUMATICA_FAILURE,
  GET_APPROVED_LINE_ITEM_REPORTS_REQUEST,
  GET_APPROVED_LINE_ITEM_REPORTS_SUCCESS,
  GET_APPROVED_LINE_ITEM_REPORTS_FAILURE,
  GET_ALL_LINEITEM_SUMMARIES_REQUEST,
  GET_ALL_LINEITEM_SUMMARIES_SUCCESS,
  GET_ALL_LINEITEM_SUMMARIES_FAILURE,
  POST_VOUCHER_START_OVER_REQUEST,
  POST_VOUCHER_START_OVER_SUCCESS,
  POST_VOUCHER_START_OVER_FAILURE
} from './types';
import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';

export const getExpenseSummaries = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EXPENSE_SUMMARIES_REQUEST, GET_EXPENSE_SUMMARIES_SUCCESS, GET_EXPENSE_SUMMARIES_FAILURE],
      authenticated: true,
      endpoint: 'api/expenses/summaries',
      method: 'GET'
    }
  };
};

export const getExpense = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EXPENSE_SUMMARY_BY_ID_REQUEST, GET_EXPENSE_SUMMARY_BY_ID_SUCCESS, GET_EXPENSE_SUMMARY_BY_ID_FAILURE],
      authenticated: true,
      endpoint: `api/expenses/${id}`,
      method: 'GET'
    }
  };
};

export const getExpenseByAuthorization = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EXPENSE_BY_AUTHORIZATION_REQUEST, GET_EXPENSE_BY_AUTHORIZATION_SUCCESS, GET_EXPENSE_BY_AUTHORIZATION_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/expenses`,
      method: 'GET'
    }
  };
};

export const createExpense = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_EXPENSE_SUMMARY_REQUEST, POST_EXPENSE_SUMMARY_SUCCESS, POST_EXPENSE_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: 'api/expenses',
      method: 'POST',
      payload: values
    }
  };
};

export const updateExpense = (values, expenseId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_EXPENSE_SUMMARY_REQUEST, UPDATE_EXPENSE_SUMMARY_SUCCESS, UPDATE_EXPENSE_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: `api/expenses/${expenseId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const resetExpense = (values, expenseId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_EXPENSE_SUMMARY_REQUEST, UPDATE_EXPENSE_SUMMARY_SUCCESS, UPDATE_EXPENSE_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: `api/expenses/${expenseId}/resetStatus`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteExpense = expenseId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_EXPENSE_SUMMARY_REQUEST, DELETE_EXPENSE_SUMMARY_SUCCESS, DELETE_EXPENSE_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: `api/expenses/${expenseId}`,
      method: 'DELETE'
    }
  };
};

export const getExpenseLineItems = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EXPENSE_LINES_REQUEST, GET_EXPENSE_LINES_SUCCESS, GET_EXPENSE_LINES_FAILURE],
      authenticated: true,
      endpoint: 'api/expenses/lineItems',
      method: 'GET'
    }
  };
};

export const createExpenseLineItems = (expenseId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_EXPENSE_LINE_REQUEST, POST_EXPENSE_LINE_SUCCESS, POST_EXPENSE_LINE_FAILURE],
      authenticated: true,
      endpoint: `api/expenses/${expenseId}/lineItems`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateExpenseLineItems = (expenseId, lineItemId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_EXPENSE_LINE_REQUEST, UPDATE_EXPENSE_LINE_SUCCESS, UPDATE_EXPENSE_LINE_FAILURE],
      authenticated: true,
      endpoint: `api/expenses/${expenseId}/lineItems/${lineItemId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteExpenseLineItem = (expenseId, lineItemId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_EXPENSE_LINE_REQUEST, DELETE_EXPENSE_LINE_SUCCESS, DELETE_EXPENSE_LINE_FAILURE],
      authenticated: true,
      endpoint: `api/expenses/${expenseId}/lineItems/${lineItemId}`,
      method: 'DELETE'
    }
  };
};

export const postBulkExpenseUpdateLineItems = (expenseId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_EXPENSE_LINE_ITEM_BULK_REQUEST, POST_EXPENSE_LINE_ITEM_BULK_SUCCESS, POST_EXPENSE_LINE_ITEM_BULK_FAILURE],
      authenticated: true,
      endpoint: `api/expenses/${expenseId}/lineItems/bulkUpdates`,
      method: 'POST',
      payload: values
    }
  };
};

export const getAllPreferredExpenseCodes = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_CLIENT_PREFERRED_EXPENSE_CODES_REQUEST,
        GET_CLIENT_PREFERRED_EXPENSE_CODES_SUCCESS,
        GET_CLIENT_PREFERRED_EXPENSE_CODES_FAILURE
      ],
      authenticated: true,
      endpoint: `api/ExpenseCodes/clientPreferred`,
      method: 'GET'
    }
  };
};

export const getVoucherSummaries = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VOUCHER_SUMMARIES_REQUEST, GET_VOUCHER_SUMMARIES_SUCCESS, GET_VOUCHER_SUMMARIES_FAILURE],
      authenticated: true,
      endpoint: 'api/vouchers/summaries',
      method: 'GET'
    }
  };
};

export const getVoucher = voucherId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VOUCHER_SUMMARY_BY_ID_REQUEST, GET_VOUCHER_SUMMARY_BY_ID_SUCCESS, GET_VOUCHER_SUMMARY_BY_ID_FAILURE],
      authenticated: true,
      endpoint: `api/vouchers/${voucherId}`,
      method: 'GET'
    }
  };
};

export const createVoucher = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_VOUCHER_SUMMARY_REQUEST, POST_VOUCHER_SUMMARY_SUCCESS, POST_VOUCHER_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: 'api/vouchers',
      method: 'POST',
      payload: values
    }
  };
};

export const updateVoucher = (voucherId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_VOUCHER_SUMMARY_REQUEST, UPDATE_VOUCHER_SUMMARY_SUCCESS, UPDATE_VOUCHER_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: `api/vouchers/${voucherId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteVoucher = voucherId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_VOUCHER_SUMMARY_REQUEST, DELETE_VOUCHER_SUMMARY_SUCCESS, DELETE_VOUCHER_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: `api/vouchers/${voucherId}`,
      method: 'DELETE'
    }
  };
};

export const getVoucherLineItems = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VOUCHER_LINES_REQUEST, GET_VOUCHER_LINES_SUCCESS, GET_VOUCHER_LINES_FAILURE],
      authenticated: true,
      endpoint: 'api/vouchers/lineItems',
      method: 'GET'
    }
  };
};

export const createVoucherLineItem = (voucherId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_VOUCHER_LINE_REQUEST, POST_VOUCHER_LINE_SUCCESS, POST_VOUCHER_LINE_FAILURE],
      authenticated: true,
      endpoint: `api/vouchers/${voucherId}/lineItems`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateVoucherLineItem = (voucherId, lineItemId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_VOUCHER_LINE_REQUEST, UPDATE_VOUCHER_LINE_SUCCESS, UPDATE_VOUCHER_LINE_FAILURE],
      authenticated: true,
      endpoint: `api/vouchers/${voucherId}/lineItems/${lineItemId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteVoucherLineItem = (voucherId, lineItemId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_VOUCHER_LINE_REQUEST, DELETE_VOUCHER_LINE_SUCCESS, DELETE_VOUCHER_LINE_FAILURE],
      authenticated: true,
      endpoint: `api/vouchers/${voucherId}/lineItems/${lineItemId}`,
      method: 'DELETE'
    }
  };
};

export const postVoucherLineItemBulk = (voucherId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_VOUCHER_LINE_ITEM_BULK_REQUEST, POST_VOUCHER_LINE_ITEM_BULK_SUCCESS, POST_VOUCHER_LINE_ITEM_BULK_FAILURE],
      authenticated: true,
      endpoint: `api/vouchers/${voucherId}/lineItems/bulkUpdates`,
      method: 'POST',
      payload: values
    }
  };
};

export const getApprovedLineItemSummaries = fileId => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_APPROVED_LINEITEM_SUMMARIES_REQUEST, GET_APPROVED_LINEITEM_SUMMARIES_SUCCESS, GET_APPROVED_LINEITEM_SUMMARIES_FAILURE],
    authenticated: true,
    endpoint: `api/authorizations/${fileId}/expenses/approved`,
    method: 'GET'
  }
});

export const getApprovedLineItem = (fileId, lineItemId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_APPROVED_LINEITEM_REQUEST, GET_APPROVED_LINEITEM_SUCCESS, GET_APPROVED_LINEITEM_FAILURE],
    authenticated: true,
    endpoint: `api/authorizations/${fileId}/expenses/approved/${lineItemId}`,
    method: 'GET'
  }
});

export const updateApprovedLineItem = (fileId, lineItemId, values) => ({
  [CALL_INTAKE_V2_API]: {
    types: [UPDATE_APPROVED_LINEITEM_REQUEST, UPDATE_APPROVED_LINEITEM_SUCCESS, UPDATE_APPROVED_LINEITEM_FAILURE],
    authenticated: true,
    endpoint: `api/authorizations/${fileId}/expenses/approved/${lineItemId}`,
    method: 'PUT',
    payload: values
  }
});

export const createApprovedCustomTax = (fileId, lineItemId, values) => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_APPROVED_TAX_REQUEST, POST_APPROVED_TAX_SUCCESS, POST_APPROVED_TAX_FAILURE],
    authenticated: true,
    endpoint: `api/authorizations/${fileId}/expenses/approved/${lineItemId}/taxes`,
    method: 'POST',
    payload: values
  }
});

export const updateApprovedCustomTax = (fileId, lineItemId, taxId, values) => ({
  [CALL_INTAKE_V2_API]: {
    types: [UPDATE_APPROVED_TAX_REQUEST, UPDATE_APPROVED_TAX_SUCCESS, UPDATE_APPROVED_TAX_FAILURE],
    authenticated: true,
    endpoint: `api/authorizations/${fileId}/expenses/approved/${lineItemId}/taxes/${taxId}`,
    method: 'PUT',
    payload: values
  }
});

export const deleteApprovedCustomTax = (fileId, lineItemId, taxId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [DELETE_APPROVED_TAX_REQUEST, DELETE_APPROVED_TAX_SUCCESS, DELETE_APPROVED_TAX_FAILURE],
    authenticated: true,
    endpoint: `api/authorizations/${fileId}/expenses/approved/${lineItemId}/taxes/${taxId}`,
    method: 'DELETE'
  }
});

export const postVoucherAttachment = (attachment, voucherId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_VOUCHER_ATTACHMENT_REQUEST, POST_VOUCHER_ATTACHMENT_SUCCESS, POST_VOUCHER_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/vouchers/${voucherId}/attachments`,
    method: 'POST',
    payload: attachment
  }
});

export const updateVoucherAttachment = (attachment, voucherId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [UPDATE_VOUCHER_ATTACHMENT_REQUEST, UPDATE_VOUCHER_ATTACHMENT_SUCCESS, UPDATE_VOUCHER_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/vouchers/${voucherId}/attachments`,
    method: 'PUT',
    payload: attachment
  }
});

export const deleteVoucherAttachment = (voucherId, attachmentId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [DELETE_VOUCHER_ATTACHMENT_REQUEST, DELETE_VOUCHER_ATTACHMENT_SUCCESS, DELETE_VOUCHER_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/vouchers/${voucherId}/attachments/${attachmentId}`,
    method: 'DELETE'
  }
});

export const addVoucherLineAttachment = (voucherId, voucherLineItemId, attachmentId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_VOUCHER_LINE_ATTACHMENT_REQUEST, POST_VOUCHER_LINE_ATTACHMENT_SUCCESS, POST_VOUCHER_LINE_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/vouchers/${voucherId}/lineItems/${voucherLineItemId}/attachments/${attachmentId}`,
    method: 'POST'
  }
});

export const removeVoucherLineAttachment = (voucherId, voucherLineItemId, attachmentId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [DELETE_VOUCHER_LINE_ATTACHMENT_REQUEST, DELETE_VOUCHER_LINE_ATTACHMENT_SUCCESS, DELETE_VOUCHER_LINE_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/vouchers/${voucherId}/lineItems/${voucherLineItemId}/attachments/${attachmentId}`,
    method: 'DELETE'
  }
});

export const postExpenseAttachment = (attachment, expenseId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_EXPENSE_ATTACHMENT_REQUEST, POST_EXPENSE_ATTACHMENT_SUCCESS, POST_EXPENSE_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/expenses/${expenseId}/attachments`,
    method: 'POST',
    payload: attachment
  }
});

export const updateExpenseAttachment = (attachment, expenseId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [UPDATE_EXPENSE_ATTACHMENT_REQUEST, UPDATE_EXPENSE_ATTACHMENT_SUCCESS, UPDATE_EXPENSE_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/expenses/${expenseId}/attachments`,
    method: 'PUT',
    payload: attachment
  }
});

export const deleteExpenseAttachment = (expenseId, attachmentId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [DELETE_EXPENSE_ATTACHMENT_REQUEST, DELETE_EXPENSE_ATTACHMENT_SUCCESS, DELETE_EXPENSE_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/expenses/${expenseId}/attachments/${attachmentId}`,
    method: 'DELETE'
  }
});

export const addExpenseLineAttachment = (expenseId, expenseLineItemId, attachmentId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_EXPENSE_LINE_ATTACHMENT_REQUEST, POST_EXPENSE_LINE_ATTACHMENT_SUCCESS, POST_EXPENSE_LINE_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/expenses/${expenseId}/lineItems/${expenseLineItemId}/attachments/${attachmentId}`,
    method: 'POST'
  }
});

export const removeExpenseLineAttachment = (expenseId, expenseLineItemId, attachmentId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [DELETE_EXPENSE_LINE_ATTACHMENT_REQUEST, DELETE_EXPENSE_LINE_ATTACHMENT_SUCCESS, DELETE_EXPENSE_LINE_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/expenses/${expenseId}/lineItems/${expenseLineItemId}/attachments/${attachmentId}`,
    method: 'DELETE'
  }
});

export const setVoucherId = id => ({
  type: SET_CURRENT_VOUCHER_ID,
  response: id
});

export const setExpenseId = id => ({
  type: SET_CURRENT_EXPENSE_ID,
  response: id
});

export const setRecurringPayableId = id => ({
  type: SET_CURRENT_RECURRING_PAYABLE_ID,
  response: id
});

export const getExceptionsByClientId = clientId => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_EXCEPTIONS_BY_CLIENT_ID_REQUEST, GET_EXCEPTIONS_BY_CLIENT_ID_SUCCESS, GET_EXCEPTIONS_BY_CLIENT_ID_FAILURE],
    authenticated: true,
    endpoint: `api/client/${clientId}/exceptions`,
    method: 'GET'
  }
});

export const getExceptionsByAuthorizationId = authorizationId => ({
  [CALL_INTAKE_V2_API]: {
    types: [
      GET_EXCEPTIONS_BY_AUTHORIZATION_ID_REQUEST,
      GET_EXCEPTIONS_BY_AUTHORIZATION_ID_SUCCESS,
      GET_EXCEPTIONS_BY_AUTHORIZATION_ID_FAILURE
    ],
    authenticated: true,
    endpoint: `api/authorizations/${authorizationId}/comments/exceptions`,
    method: 'GET'
  }
});

export const pushVoucherToAcumatica = voucherId => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_PUSH_VOUCHER_TO_ACUMATICA_REQUEST, POST_PUSH_VOUCHER_TO_ACUMATICA_SUCCESS, POST_PUSH_VOUCHER_TO_ACUMATICA_FAILURE],
    authenticated: true,
    endpoint: `api/vouchers/${voucherId}/push`,
    method: 'POST'
  }
});

export const pushExpenseToAcumatica = expenseId => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_PUSH_EXPENSE_TO_ACUMATICA_REQUEST, POST_PUSH_EXPENSE_TO_ACUMATICA_SUCCESS, POST_PUSH_EXPENSE_TO_ACUMATICA_FAILURE],
    authenticated: true,
    endpoint: `api/expenses/${expenseId}/push`,
    method: 'POST'
  }
});


export const getApprovedLineItemReports = (request) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_APPROVED_LINE_ITEM_REPORTS_REQUEST, GET_APPROVED_LINE_ITEM_REPORTS_SUCCESS, GET_APPROVED_LINE_ITEM_REPORTS_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/expenses/approvedLines',
      method: 'POST',
      payload: request
    }
  };
};

export const getAllLineItemSummaries = fileId => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_ALL_LINEITEM_SUMMARIES_REQUEST, GET_ALL_LINEITEM_SUMMARIES_SUCCESS, GET_ALL_LINEITEM_SUMMARIES_FAILURE],
    authenticated: true,
    endpoint: `api/authorizations/${fileId}/expenses/summaries`,
    method: 'GET'
  }
});

export const startOverVoucher = (voucherId, request) => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_VOUCHER_START_OVER_REQUEST, POST_VOUCHER_START_OVER_SUCCESS, POST_VOUCHER_START_OVER_FAILURE],
    authenticated: true,
    endpoint: `api/vouchers/${voucherId}/startOver`,
    method: 'POST',
    payload: request
  }
});